interface DamageFlagBadgeProps {
  label?: string;
  className?: string;
}

/**
 * A loud, filled chip so an open damage dispute is impossible to miss.
 * Uses the secondary (rust) role so it flips cleanly between light and dark themes.
 */
export default function DamageFlagBadge({ label = "Damage flagged", className = "" }: DamageFlagBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-500 px-2.5 py-1 text-xs font-medium text-background-50 ${className}`}
    >
      <i className="ri-alert-line"></i>
      {label}
    </span>
  );
}